import React from 'react';
import { useOwner } from '../context/context';
import { useAccount } from '../context/accountContext';
import { i18nIntl, isAppOld } from '../../lib/ep';

import Module from './Module';

import ActionButton, { BackButton } from '../builder/ActionButton';
import SaveFeedback from '../builder/SaveFeedback';

import OwnerMainHeader from '../backend/OwnerMainHeader';
import MainMenuWrapper from '../backend/MainMenuWrapper';
import CopyOptions from '../backend/elements/CopyOptions';

import SimpleListOfItems from './SimpleListOfItems';
import Tooltip from '../builder/Tooltip';
import { chargebee_item, priceCustomDaysPlan } from '../backend/Subscriptions';
import ChargeBee from '../backend/ChargeBee';

const TrullyExpiredPromotion = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const owner = useOwner();
	const promotion = owner?.promotion?.Promotion ?? false;
	const promotion_type = owner?.promotion?.PromotionType ?? false;

	const is_old_app = isAppOld(promotion_type?.id ?? 2);//Per si de cas, posem el 2 que no es copiable
	let label_copy_disabled = i18n("This promotion is classified as old because it uses the old Easypromos promotion engine, and it is no longer allowed to make copies of it. Please create a new promotion of the same type using the new engine, which will offer a better user experience in terms of speed, security, and features.");
	if((promotion_type?.id ?? 2) == '15'){
		label_copy_disabled = props.intl.formatMessage({ id:"This promotion is classified as old because it uses the old Easypromos engine, and it is no longer allowed to make copies of it. Please create a new promotion using the {label_new_app} application, which will offer a better user experience in terms of speed, security and features." }, { label_new_app:`"${i18n("Instagram Contest with Hashtag")}"`})
	}
	
	let type_url,type_label,plan_type = '';
	let allowed_passday = true;
	switch(promotion.promo_type) {
		case '2':
			plan_type = '5';
			type_label = "White Label Plan";
			type_url = 'wl';
			break;
		
		case '1':
			plan_type = '4';
			type_label = "Premium Plan";
			type_url = 'premium';
			break;

		case '0':
			allowed_passday = false;
			plan_type = '2';
			type_label = "Basic Plan";
			type_url = 'basic';
			break;
	}

	const options_plan = [];
	if(allowed_passday){
		options_plan.push({
			id:'plan1',
			icon:'knk-subscription',
			title:props.intl.formatMessage({
				id:"Activate a {plan} for {periodicity} {price}"
			}, {
				plan:i18n(type_label),
				periodicity:`<strong>${i18n("1 day")}</strong>:`,
				price:`<strong>${priceCustomDaysPlan(plan_type,'1day',window.currency)}</strong>`,
			}),
			actions:<ChargeBee
				account_id={owner.account.id}
				item_id={chargebee_item(plan_type,'1day',window.currency)}
				type={'plan'}
				quantity={1}
				onSuccess={()=>{
					setCookie('processing_redirect',`/promotions/profile/${promotion.id}`,1,'.easypromosapp.com');	
					window.location.href=`/payments/processing`;
				}}
				autotranslate={false}
			><strong>{i18n("Activate")}</strong></ChargeBee>,
		});

		options_plan.push({
			id:'plan3',
			icon:'knk-subscription',
			title:props.intl.formatMessage({
				id:"Activate a {plan} for {periodicity} {price}"
			}, {
				plan:i18n(type_label),
				periodicity:`<strong>${i18n("3 days")}</strong>:`,
				price:`<strong>${priceCustomDaysPlan(plan_type,'3day',window.currency)}</strong>`,
			}),
			actions:<ChargeBee
				account_id={owner.account.id}
				item_id={chargebee_item(plan_type,'3day',window.currency)}
				type={'plan'}
				quantity={1}
				onSuccess={()=>{
					setCookie('processing_redirect',`/promotions/profile/${promotion.id}`,1,'.easypromosapp.com');	
					window.location.href=`/payments/processing`;
				}}
				autotranslate={false}
			><strong>{i18n("Activate")}</strong></ChargeBee>,
		});
	}

	options_plan.push({
		id:'plan30',
		icon:'knk-subscription',
		title:props.intl.formatMessage({
			id:(allowed_passday) ? "Activate a {periodicity} {plan} {price}" : "Activate a plan to access closed promotions" 
		}, {
			plan:i18n(type_label),
			price:`: <strong>${priceCustomDaysPlan(plan_type,'Monthly',window.currency)}</strong>`,
			periodicity:`<strong>${i18n("monthly")}</strong>`,
		}),
		actions:<ActionButton
			_href={`${window.panel_url}plans/add/${type_url}?closed_promotion`}
			autotranslate={false}
		><strong>{(allowed_passday) ? i18n("Activate") : `${i18n("Activate")} ${i18n(type_label)}`}</strong></ActionButton>,
	});
	
	const options_promotion = [{
		id:'delete',
		icon:'knk-delete redIcon',
		title:"Delete the promotion and all its users",
		actions:<ActionButton
			_href={`/promotions/confirm_delete/${promotion.id}`}
		>Delete promotion</ActionButton>,
	}, {
		id:'copy',
		icon:'knk-copy',
		title:"Create a new promotion based on this one",
		actions: !is_old_app ? <CopyOptions
			without_icon=''
			type='button'
			promotion={promotion}
			promotion_type={promotion_type}
			has_codesets={props?.has_codesets ?? false}
			has_hashtag_integrations={props?.has_hashtag_integrations ?? false}
			has_custom_domain={props?.has_custom_domain ?? false}
		/>: <ActionButton
			icon='knk-copy grayIcon'
			_class={{ other:'copyPromo grayText' }}
			//disabled={true}
			autotranslate={false}
			style={{ '--main-color':'170, 170, 170' }}
			tooltip={<Tooltip
				with_icon={false}
				position='right'
				autotranslate={false}
			>{label_copy_disabled}</Tooltip>}
		>{i18n("copy promotion", 'ucfirst')}</ActionButton>,
	}];

	return (
		<Module
			title="The promotion has been closed"
			subtitle={<>
				<p class='gui_not_in_top'>{i18n("Promotions automatically close 30 days after being unpublished.")} <strong>{props.intl.formatMessage({ id:"This promotion closed on {date} at {hour} {tz}." }, { date:EPDateAddAndFormat(promotion.end_date, 'months', 1, 'LL'), hour:EPDateFormat(promotion.end_date, 'h:mm'), tz:` ${defaultTimezones(promotion.timezone)}` })}</strong></p>

				<p>
					{props.intl.formatMessage({
						id:"To access a closed promotion and view or download the list of participants, the statistics history, or its settings, it is necessary to have an active {plan}."
					}, {
						plan:i18n(type_label),
					})}
				</p>
			</>}
			actions={<BackButton _href={`${window.panel_url}promotions`} />}
		>
			<article class='gui_not_in_top' style={{ display:'flex', justifyContent:'center'}}>
				<div style={{ width:'45em' }}>
					<p class="gui_not_in_top gui_not_in_bottom_small">{i18n("What actions can you take?")}</p>
					{(allowed_passday) ? (
						<ul>
							<li>
								<p class="gui_not_in_bottom_tiny gui_force_bold">{`${i18n("Activate a plan to access closed promotions")}.`}</p>
								<div style={{ border:'1px solid rgba(var(--main-text-color), 0.1)' }}>
									<SimpleListOfItems
										items={options_plan}
										overflowed={false}
										classes="gui_force_roman"
									/>
								</div>
							</li>
							<li>
								<div class="gui_not_in_top" style={{ border:'1px solid rgba(var(--main-text-color), 0.1)' }}>
									<SimpleListOfItems
										items={options_promotion}
										overflowed={false}
									/>
								</div>
							</li>
						</ul>
					) : (
						<div style={{ border:'1px solid rgba(var(--main-text-color), 0.1)' }}>
							<SimpleListOfItems
								items={[...options_plan, ...options_promotion]}
								overflowed={false}
							/>
						</div>
					)}
					
				</div>
			</article>
		</Module>
	)
};

const Wrapper = (props) => {
	const header = props?.header ?? true;
	const custom_header = props?.custom_header ?? false;
	const menu = props?.menu ?? 'profile';

	const sticky_header = props?.sticky_header ?? false;
	const on_top_level = props?.on_top_level ?? true;	// "false" if banner sidebar is needed (then the main_classes will be in promo_profile.ctp)

	const main_classes = [];
	if(on_top_level) {
		main_classes.push('promo_profile', 'profile_grid', 'gui_grid');
		if(menu === false) main_classes.push('without_menu');
	}

	let header_styles = null;
	const header_classes = ['grid_header'];
	if(sticky_header !== false) {
		header_classes.push('gui_pos_sticky_important');
		header_styles = { top:sticky_header, zIndex:2 };
	}

	return (
		<section class={main_classes.join(" ")}>
			{(header !== false) && (
				<div class={header_classes.join(" ")} style={header_styles}>
					{(!custom_header) ? (
						<OwnerMainHeader
							{...props}
							is_simple={props.simple_header}
						/>
					) : (
						custom_header
					)}
				</div>
			)}

			{props.children}

			{(props.sidebar != undefined) && (
				props.sidebar
			)}
		</section>
	)
};

const OwnerPromoWrapper = ({ ...props }) => {
	const owner = useOwner();
	const { MyAccount } = useAccount();
	/*
	VARIABLES PER AL MainMenuWrapper
		promotion					// objecte promotion (amb Promotion, PromotionType, CustomFields, etc)
		status						// 'draft', 'active', 'old'
		is_agent_admin				// true / false
		account						// objecte Account directe de sessió

		organizer_id				// label_id
		agent						// sesssió de PHP amb $agent (ha de contenir .Agent a dins)
		creator						// objecte de tipus agent (amb .Agent a dins) del creador de la promo
		agent_activator				// objecte de tipus agent (amb .Agent a dins) de l'activador de la promo
		agent_promotion_role		// 'administrator', 'editor', 'analyst', 'designer', etc
		role						// ?
		force_login					// true / false
		has_login_enabled			// true / false
		is_collaborator				// true / false
		has_media					// true / false
		has_codesets				// true / false
		has_hashtag_integrations	// true / false
		has_custom_domain			// true / false
		has_available_subscription	// true / false
		current_active				// número
		quizMonitor					// true / false
		


	VARIABLES PER AL OwnerMainHeader:
		promotion					// objecte promotion (amb Promotion, PromotionType, CustomFields, etc)
		status						// 'draft', 'active', 'old'
		is_agent_admin				// true / false
		
		in_profile					= true / false
		until_seconds				= '<?=strtotime($timestamp_end) - strtotime($now)?>';
		type						= 'promotion';
		languages					= JSON.parse('<?=safeJSON(getPromotionLocales($promotion, true));?>');
		domain						= '<?=$dom?>';
		shared_with_me				= '<?=$account['Account']['id']!=$promotion['Promotion']['account_id'] ? true : false?>';
		organizers					= JSON.parse('<?=safeJSON($labels_organizer);?>');
		promo_labels				= JSON.parse('<?=safeJSON($promotion_labels, true)
	*/


	/*
	PROPS passades (desde Integrations.js):
		promotion					// objecte promotion (amb Promotion, PromotionType, CustomFields, etc)
	*/
	const menu = props?.menu ?? 'profile';	// indicates which version of the menu must be displayed. If false, no menu will be shown
	const add_module = props?.add_module ?? true;
	
	const grid_main_contents = props?.grid_main_contents ?? true;
	const trully_expired_no_plan = (owner.trully_expired && !MyAccount.hasMinPlan(owner.available_plan_type)) ? true : false;
	const skip_closed_promotion = props?.skip_closed_promotion ?? false;

	if(trully_expired_no_plan && !skip_closed_promotion) {
		return (
			<Wrapper
				{...props}
				menu={false}
			>
				<TrullyExpiredPromotion
					{...props}
				/>
			</Wrapper>
		)
	}

	return (
		<Wrapper
			{...props}
			menu={menu}
		>
			{(menu !== false) && (
				<div class="grid_sidebar">
					<MainMenuWrapper
						menu={menu}
						{...props}
					/>
				</div>
			)}

			<div class={(grid_main_contents) ? "grid_container gui_grid" : null}>
				{(add_module) ? (
					<Module>
						{props.children}
					</Module>
				) : (
					props.children
				)}
			</div>

			<SaveFeedback />
		</Wrapper>
	)
};

export default OwnerPromoWrapper;